import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import DashboardLayout from 'src/layouts/dashboard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/user-profile/index'));

// ----------------------------------------------------------------------
export const userProfileRoutes = [
  {
    path: 'user-profile',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [{ element: <IndexPage />, index: true }],
  },
];
